import { makeAPICall } from 'models/api';
import { API_URL } from 'config';
import {
    Feature as GeoJsonFeature,
    GeoJsonProperties,
    Geometry as GeoJsonGeometry,
} from 'geojson';

export declare namespace API {
    export interface Redlining {
        id: number;
        name: string;
        priority: string;
        bfmcId: number;
        created_by: string;
        modified_by: string;
    }

    export interface ActionResponse {
        success: boolean;
        error?: string;
    }
}

export interface Redlining {
    id: number;
    name: string;
    priority: string;
    bfmcId: number;
    createdBy: string;
    modifiedBy: string;
}

const REDLINING_ROUTE = `${API_URL}/redlining`;

export const mapAPIToRedline = ({
    created_by,
    modified_by,
    ...rest
}: API.Redlining): Redlining => ({
    ...rest,
    createdBy: created_by,
    modifiedBy: modified_by,
});

export interface RedliningDelete {
    id: number;
}

export const deleteRedlining = makeAPICall<
    API.ActionResponse,
    RedliningDelete,
    API.ActionResponse
>(
    ({ id }) => {
        return {
            url: `${REDLINING_ROUTE}/${id}`,
            contentType: null,
            requestData: {
                method: 'DELETE',
            },
        };
    },
    (x) => x,
);

export interface RedliningCreate {
    feature: GeoJsonFeature<GeoJsonGeometry, GeoJsonProperties>;
}

export const addRedlining = makeAPICall<
    Redlining,
    RedliningCreate,
    API.Redlining
>(
    ({ feature }) => {
        return {
            url: `${REDLINING_ROUTE}?plan_id=${feature.properties?.plan_id}`,
            requestData: {
                contentType: 'application/json',
                method: 'POST',
                body: JSON.stringify(feature),
            },
        };
    },
    (x) => mapAPIToRedline(x),
);

export interface RedliningUpdate {
    feature: GeoJsonFeature<GeoJsonGeometry, GeoJsonProperties>;
    id: number;
}

export const editRedlining = makeAPICall<
    Redlining,
    RedliningUpdate,
    API.Redlining
>(
    ({ feature, id }) => {
        return {
            url: `${REDLINING_ROUTE}/${id}?plan_id=${feature.properties?.plan_id}`,
            requestData: {
                contentType: 'application/json',
                method: 'PUT',
                body: JSON.stringify(feature),
            },
        };
    },
    (x) => mapAPIToRedline(x),
);
